import { createContext } from 'react';

export type Theme = 'light' | 'dark' | 'system';
export type ActualTheme = 'light' | 'dark';

export interface ThemeContextType {
    theme: Theme;
    actualTheme: ActualTheme;
    setTheme: (theme: Theme) => void;
}

export const ThemeContext = createContext<ThemeContextType | undefined>(undefined);
